export const policyTypes = [
  { label: "Comprehensive/ Package", value: "Comprehensive/ Package" },
  { label: "Third Party Only/ TP", value: "Third Party Only/ TP" },
  { label: "Own Damage Only/ OD", value: "Own Damage Only/ OD" },
];

export const caseTypes = [
  { label: "New", value: "New" },
  { label: "Rollover", value: "Rollover" },
  { label: "Renewal", value: "Renewal" },
];

export const lobs = [
  { label: "Motor", value: "Motor" },
  { label: "Non Motor", value: "Non Motor" },
  { label: "Health", value: "Health" },
  { label: "Life", value: "Life" },
];
export const categoryTypes = [
  { id: "1", label: "Two Wheelers", value: "Two Wheelers" },
  { id: "2", label: "Private Car", value: "Private Car" },
  { id: "3", label: "Pccv up to 6 passenger", value: "Pccv up to 6 passenger" },
  { id: "4", label: "Pccv Above 6 passenger", value: "Pccv Above 6 passenger" },
  { id: "5", label: "Goods carrying vehicle", value: "Goods carrying vehicle" },
  { id: "6", label: "Miscellaneous", value: "Miscellaneous" },
];

export const subCategoryTypes = [
  {
    id: "3",
    label: "2 Wheeler Passenger Carrying",
    value: "2 Wheeler Passenger Carrying",
  },
  {
    id: "3",
    label: "3 Wheeler up to 6 passenger",
    value: "3 Wheeler up to 6 passenger",
  },
  { id: "3", label: "Taxi Car", value: "Taxi Car" },
  { id: "3", label: "E- Rickshaw", value: "E- Rickshaw" },
  {
    id: "4",
    label: "3 Wheeler above 6 Passenger ",
    value: "3 Wheeler above 6 Passenger ",
  },
  { id: "4", label: "Route Bus", value: "Route Bus" },
  { id: "4", label: "School Bus", value: "School Bus" },
  { id: "4", label: "Corporate Bus", value: "Corporate Bus" },
  { id: "4", label: "Staff Bus", value: "Staff Bus" },
  {
    id: "5",
    label: "3 Wheeler Public Carrying",
    value: "3 Wheeler Public Carrying",
  },
  { id: "5", label: "E-Cart Public Carrying", value: "E-Cart Public Carrying" },
  {
    id: "5",
    label: "GCCV public (0-1600 kg)",
    value: "GCCV public (0-1600 kg)",
  },
  {
    id: "5",
    label: "GCCV public (1600-2000 kg)",
    value: "GCCV public (1600-2000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (2000-2500 kg)",
    value: "GCCV public (2000-2500 kg)",
  },
  {
    id: "5",
    label: "GCCV public (2500-3000 kg)",
    value: "GCCV public (2500-3000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (3000-7000 kg)",
    value: "GCCV public (3000-7000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (7000-7500 kg)",
    value: "GCCV public (7000-7500 kg)",
  },
  {
    id: "5",
    label: "GCCV public (7500-12000 kg)",
    value: "GCCV public (7500-12000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (12000-20000 kg)",
    value: "GCCV public (12000-20000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (20000-25000 kg)",
    value: "GCCV public (20000-25000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (25000-40000 kg)",
    value: "GCCV public (25000-40000 kg)",
  },
  {
    id: "5",
    label: "GCCV public (above 40000 kg)",
    value: "GCCV public (above 40000 kg)",
  },
  { id: "6", label: "Agriculture Tractor", value: "Agriculture Tractor" },
  { id: "6", label: "JCB", value: "JCB" },
  { id: "6", label: "Misc D", value: "Misc D" },
  { id: "6", label: "Garbage Van", value: "Garbage Van" },
  { id: "6", label: "Ambulance", value: "Ambulance" },
];

export const companiesName = [
  {
    label: "Bajaj Allianz General Insurance",
    value: "Bajaj Allianz General Insurance",
  },
  {
    label: "Cholamandalam MS General Insurance",
    value: "Cholamandalam MS General Insurance",
  },
  { label: "Digit Insurance", value: "Digit Insurance" },
  {
    label: "Zuno General Insurance Limited",
    value: "Zuno General Insurance Limited",
  },
];

export const brokers = [
  {
    label: "AIBROM INSURANCE BROKING PVT. LTD.",
    value: "AIBROM INSURANCE BROKING PVT. LTD.",
  },
  {
    label: "SAFE KARO PREM CHOUDHARY",
    value: "SAFE KARO PREM CHOUDHARY",
  },
  {
    label: "SQUARE INSURANCE BROKER PVT LTD",
    value: "SQUARE INSURANCE BROKER PVT LTD",
  },
  {
    label: "PROBUS INSURANCE BROKER LTD",
    value: "PROBUS INSURANCE BROKER LTD",
  },
];

export const makes = [
  { label: "MAHINDRA & MAHINDRA", value: "MAHINDRA & MAHINDRA" },
  { label: "TATA", value: "TATA" },
  { label: "PIAGGIO", value: "PIAGGIO" },
  { label: "ATUL", value: "ATUL" },
  { label: "A V AUTOMOTIVES PVT", value: "A V AUTOMOTIVES PVT" },
  { label: "AADHYA ENTERPRISES", value: "AADHYA ENTERPRISES" },
  { label: "BAJAJ", value: "BAJAJ" },
];

export const models = [
  { label: "BOLERO PICKUP", value: "BOLERO PICKUP" },
  { label: "BOLERO CAMPER", value: "BOLERO CAMPER" },
  { label: "SUPRO / MAXI TRUCK", value: "SUPRO / MAXI TRUCK" },
  { label: "COMMANDER", value: "COMMANDER" },
];

export const fuelTypes = [
  { label: "Diseal", value: "Diseal" },
  { label: "Petrol", value: "Petrol" },
  { label: "LPG", value: "LPG" },
  { label: "CNG", value: "CNG" },
  { label: "ELECTRIC", value: "ELECTRIC" },
];

export const paymentModes = [
  { label: "Online", value: "Online" },
  { label: "Cash", value: "Cash" },
  { label: "Cheque", value: "Cheque" },
];
export const policyCreatedByAdmin = [{ label: "Partner", value: "Partner" }];

export const policyCreatedBy = [
  { label: "Partner", value: "Partner" },
  { label: "Relationship Manager", value: "Relationship Manager" },
];

export const documentTypes = [
  { label: "RC Front", value: "rcFront" },
  { label: "RC Back", value: "rcBack" },
  { label: "Survey", value: "survey" },
  { label: "PUC", value: "puc" },
  { label: "Fitness", value: "fitness" },
  { label: "Proposal", value: "proposal" },
  { label: "Current Policy", value: "currentPolicy" },
  { label: "Previous Policy", value: "previousPolicy" },
  { label: "Other", value: "other" },
];

export const userDocumentList = [
  { label: "image", value: "image" },
  {
    label: "Adhar Card Front",
    value: "adharCardFront",
  },
  { label: "Adhar Card Back", value: "adharCardBack" },
  { label: "PanCard", value: "panCard" },
  { label: "Qualification", value: "qualification" },
  { label: "Bank Proof", value: "bankProof" },
  { label: "Experience", value: "experience" },
  { label: "other", value: "other" },
];
